import React from 'react';
import { DateRangeDropdownV2, FormFieldV2, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { chungTuSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { ChungTu, KhachHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formMode: 'add' | 'edit' | 'view';
}

const BasicInfoTab = ({ formMode }: BasicInfoTabProps) => {
  return (
    <div className='p-4'>
      {/* Ngày c/từ (từ/đến) */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Ngày c/từ (từ/đến)</Label>
        <div className='w-[430px]'>
          <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-[150px]'>Chứng từ</Label>
        <FormFieldV2
          name='ma_ct'
          type='text'
          disabled={true}
          options={[
            { value: 'HD4', label: 'Hóa đơn mua hàng trong nước' },
            { value: 'HD5', label: 'Hóa đơn mua hàng nhập khẩu' },
            { value: 'HD7', label: 'Hóa đơn nhập mua - xuất thẳng' }
          ]}
        />
      </div>

      {/* Mã khách hàng */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã đối tượng</Label>
        <SearchField<KhachHang>
          type='text'
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          className='w-[205px]'
        />
      </div>

      {/* Tài khoản nợ */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Số hoá đơn</Label>
        <SearchField<ChungTu>
          type='text'
          name='so_ct'
          searchEndpoint={`/${QUERY_KEYS.CHUNG_TU}/`}
          searchColumns={chungTuSearchColumns}
          columnDisplay='ma_ct'
          displayRelatedField='ten_ct'
          dialogTitle='Chọn chứng từ'
          className='w-[205px]'
        />
      </div>

      <div className='flex items-center pt-4'>
        <Label className='w-[150px]'>Xử lý</Label>
        <FormFieldV2
          name='dataType'
          type='select'
          options={[
            { value: '1', label: 'Thêm vào chi tiết' },
            { value: '2', label: 'Xóa hết chi tiết và thêm mới' }
          ]}
          className='w-[360px]'
        />
      </div>

      <div className='flex items-center pt-4'>
        <Label className='w-[150px]'>Chọn tất cả</Label>
        <FormFieldV2 name='chon_all' type='checkbox' />
      </div>
    </div>
  );
};

export default BasicInfoTab;
